/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InlineResponse2003OffersStatus model module.
 * @module model/InlineResponse2003OffersStatus
 * @version v1
 */
class InlineResponse2003OffersStatus {
    /**
     * Constructs a new <code>InlineResponse2003OffersStatus</code>.
     * @alias module:model/InlineResponse2003OffersStatus
     */
    constructor() { 
        
        InlineResponse2003OffersStatus.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineResponse2003OffersStatus</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineResponse2003OffersStatus} obj Optional instance to populate.
     * @return {module:model/InlineResponse2003OffersStatus} The populated <code>InlineResponse2003OffersStatus</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineResponse2003OffersStatus();

            if (data.hasOwnProperty('total')) {
                obj['total'] = ApiClient.convertToType(data['total'], 'Number');
            }
            if (data.hasOwnProperty('unpublished')) {
                obj['unpublished'] = ApiClient.convertToType(data['unpublished'], 'Number');
            }
            if (data.hasOwnProperty('published')) {
                obj['published'] = ApiClient.convertToType(data['published'], 'Number');
            }
            if (data.hasOwnProperty('closed')) {
                obj['closed'] = ApiClient.convertToType(data['closed'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} total
 */
InlineResponse2003OffersStatus.prototype['total'] = undefined;

/**
 * @member {Number} unpublished
 */
InlineResponse2003OffersStatus.prototype['unpublished'] = undefined;

/**
 * @member {Number} published
 */
InlineResponse2003OffersStatus.prototype['published'] = undefined;

/**
 * @member {Number} closed
 */
InlineResponse2003OffersStatus.prototype['closed'] = undefined;






export default InlineResponse2003OffersStatus;

